// extracted by mini-css-extract-plugin
module.exports = {"JobBoardContainer":"JobBoardContainer_JobBoardContainer__1KY0p","FiltersLegendWrapper":"JobBoardContainer_FiltersLegendWrapper__3LBmj"};